<template>
  <div>
    <div class="page-title">New Role</div>
    <Form v-if="form" v-model="form" :submit="create" btnText="Add Role" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.participant-role.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.Role.new();
      this.form = data;
    },
    async create() {
      await this.$api.Role.create(this.form);
      this.$router.push("/users/participants");
    },
  },
};
</script>

<style></style>
